import { Observable } from 'rxjs';
import AxiosSubscriber from '../../factory/AxiosSubscriber';

export class ListAttachmentAPI {
  constructor() {
    this.subscription = null;
  }

  subscribe(token, next, complete, error) {
    const httpConfig = {
      url: `/g/guest/data`,
      method: 'get',
      headers: {
        'accept': 'application/json',
        'Content-Type': `application/json`,
        'Authorization': `Bearer ${token}`
      }
    };

    let observable$ = new Observable((observer) => {
      return new AxiosSubscriber(observer, httpConfig, false);
    });

    this.subscription = observable$.subscribe({
      next: next,
      complete: complete,
      error: error
    });
  }

  unsubscribe() {
    if (this.subscription !== undefined && this.subscription !== null) {
      this.subscription.unsubscribe();
    }
  }
}